<template>
  <div class='SDAU_style'>
    <div style='margin-top:32px;display:flex;justify-content: space-between;'>
      <div style='width: 200px;'>
        <el-menu :default-active="menuIndex" class="el-menu-vertical-demo" @select="handleOpen">
          <el-menu-item index="1">
            <span slot="title">工作台</span>
          </el-menu-item>
          <el-menu-item index="2">
            <span slot="title">预约记录</span>
          </el-menu-item>
          <el-menu-item index="3">
            <span slot="title">使用记录</span>
          </el-menu-item>
          <el-menu-item index="4">
            <span slot="title">考核信息</span>
          </el-menu-item>
          <el-menu-item index="5">
            <span slot="title">扣分记录</span>
          </el-menu-item>
        </el-menu>
      </div>
      <workbench v-if="menuIndex=='1'" />
      <appointmentcompent v-if="menuIndex=='2'" />
      <usageRecord v-if="menuIndex=='3'" />
      <examinationMessage v-if="menuIndex=='4'" />
      <penaltyRecord v-if="menuIndex=='5'" />
    </div>
  </div>
</template>
<script>
import workbench from './components/workbench/workbench.vue'
import appointmentcompent from './components/appointmentRecord.vue'
import usageRecord from './components/usageRecord.vue'
import examinationMessage from './components/examinationMessage.vue'
import penaltyRecord from './components/penaltyRecord.vue'
export default {
  components: {
    workbench, appointmentcompent, usageRecord, examinationMessage, penaltyRecord
  },
  data() {
    return {
      menuIndex: '1',
    }
  },
  methods: {
    handleOpen(index) {
      this.menuIndex = index
    },
  },
  created() {
  },
}
</script>
<style lang="scss" scoped>
::v-deep.el-menu-vertical-demo {
  height: 360px;
  border: 1px solid #d7dce0;
  .el-menu-item {
    width: 100%;
    height: 72px;
    line-height: 72px;
    border-bottom: 1px solid #d7dce0;
    font-size: 16px;
    font-family: Source Han Sans SC;
    font-weight: 700;
    // color: #333333;
  }
  .el-menu-item:last-child {
    border-bottom: 1px solid transparent;
  }
}

::v-deep.longForm {
  .el-form-item__content {
    width: 90%;
  }
}
</style>